export function getCurrentLanguage() {
  const documentLanguage = document.documentElement.lang?.trim().toLowerCase() || "en";
  const language = documentLanguage.split("-")[0];

  if (language === "ua") return "uk";

  return language;
}
